import { render, staticRenderFns } from "./korpay.vue?vue&type=template&id=a47295b2&scoped=true&"
import script from "./korpay.vue?vue&type=script&lang=js&"
export * from "./korpay.vue?vue&type=script&lang=js&"
import style0 from "./korpay.vue?vue&type=style&index=0&id=a47295b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47295b2",
  null
  
)

export default component.exports